import { useState, useEffect } from "react";

interface UserInfo {
  email: string;
  roles: string[];
}

export function useUserInfo(): UserInfo {
  const [userInfo, setUserInfo] = useState<UserInfo>({
    email: "",
    roles: [],
  });

  useEffect(() => {
    try {
      const data = localStorage.getItem("barte-user-info");
      if (data) {
        const parsed = JSON.parse(data);

        setUserInfo({
          email: parsed?.email ?? "",
          roles: Array.isArray(parsed?.roles) ? parsed.roles : [],
        });
      }
    } catch (err) {
      console.error("Erro ao carregar barte-user-info:", err);
    }
  }, []);

  return userInfo;
}
